import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";

import {
  INTENT_PROJECT_SUCCESS_MESSAGES,
  REFETCH_INTENT_PROJECT_AND_ATTACHABLE_INTEGRATIONS_QUERIES,
} from "../constants";
import { ATTACH_AWS_INTEGRATION_TO_INTENT_PROJECT } from "./gql";

const useAttachIntegration = () => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const [attachMutation, { loading, error }] = useMutation(
    ATTACH_AWS_INTEGRATION_TO_INTENT_PROJECT,
    {
      refetchQueries: REFETCH_INTENT_PROJECT_AND_ATTACHABLE_INTEGRATIONS_QUERIES,
      awaitRefetchQueries: true,
    }
  );

  const attachIntegration = useCallback(
    async (input: {
      intentProjectId: string;
      integrationId: string;
      read: boolean;
      write: boolean;
      awsRegion: string;
    }): Promise<void> => {
      try {
        const result = await attachMutation({
          variables: {
            intentProject: input.intentProjectId,
            integration: input.integrationId,
            read: input.read,
            write: input.write,
            awsRegion: input.awsRegion,
          },
        });

        if (result.data?.awsIntegrationIntentProjectAttach?.id) {
          reportSuccess({ message: INTENT_PROJECT_SUCCESS_MESSAGES.INTEGRATION_ATTACHED });
        }
      } catch (error) {
        onError(error);
      }
    },
    [attachMutation, onError, reportSuccess]
  );

  return {
    attachIntegration,
    loading,
    error,
  };
};

export default useAttachIntegration;
